export const handleInputValue = (
  value: string | number,
  options?: any,
): string | number | undefined => {
  return value === "" ? options?.emptyValue || undefined : value;
};
